import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "@fontsource-variable/big-shoulders-display/wght";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/fraunces/opsz";
import "./styles/index.css";
import { App } from "./App";
import { initPwa } from "./lib/pwa";

initPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
